import { Component, OnInit, ViewChild } from '@angular/core';

//DSS Documentation on SocoModalService - http://tiny.sc/cgsocomodalservice
import { SocoModalService } from '@soco/modal';

import { UserService } from '../user.service';
import { User } from '../user';
import { UserAddComponent } from '../add/user-add.component';
import { UserEditComponent } from '../edit/user-edit.component';

@Component({
    selector: 'user-list',
    templateUrl: 'user-list.component.html'
})
export class UserListComponent implements OnInit {
    isLoading: boolean = true;
    users: User[] = [];

    @ViewChild(UserAddComponent, { static: false }) userAddComponent: UserAddComponent;
    @ViewChild(UserEditComponent, { static: false })userEditComponent: UserEditComponent;

    //DSS Documentation on SocoConfigurationService - http://tiny.sc/cgsococonfigurationservice
    //DSS Documentation on SocoModalService - http://tiny.sc/cgsocomodalservice
    constructor(private userService: UserService, private socoModalService: SocoModalService) { }

    ngOnInit(): void {
        this.getAll();
    }

    //=============================================================================================================
    //EVENT HANDLERS
    //=============================================================================================================
    add(): void {
        this.userAddComponent.show();
    }

    edit(id: number): void {
        this.userEditComponent.show(id);
    }

    delete(user: User): void {
        //DSS Documentation on SocoModalService - http://tiny.sc/cgsocomodalservice
        this.socoModalService.confirm({
            title: 'Delete?',
            body: 'Are you sure you want to delete the user?',
            dontCloseOnChoice: true,
            confirmationCallback: (confirmed: boolean) => {
                if (confirmed) {
                    this.del(user.id);
                }
                else {
                    this.socoModalService.hide();
                }
            }
        });
    }

    userAddClosed(): void {
        this.getAll();
    }

    userEditClosed(): void {
        this.getAll();
    }

    //=============================================================================================================
    //WEB METHODS
    //=============================================================================================================
    private getAll(): void {
        this.isLoading = true;
        this.userService.getAll().subscribe(result => {
            this.isLoading = false;
            this.users = result.data;
        });
    }

    private del(id: number): void {
        this.userService.del(id).subscribe(result => {
            //DSS Documentation on SocoModalService - http://tiny.sc/cgsocomodalservice
            this.socoModalService.hide();
            this.getAll();
        });
    }
}

